// Base service name
export const SERVICE_NAME = "FONT_SERVICE";
